import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { getLabel } from './utils';

import './form.scss';

const TextInput = React.forwardRef(({ label, error, hint, required, ...inputProps }, ref) => {
    const hasError = error && error.length > 0;
    const inputClasses = classNames({
        'ml-form-field': true,
        'error': hasError,
    });

    return (
        <div className={inputClasses}>
            <label>
                <span key="label">{ getLabel(label, inputProps.name, required) }</span>
                <input
                    key="input"
                    ref={ref}
                    autoFocus={inputProps.autoFocus}
                    type="text"
                    {...inputProps}
                />
                { hint && <div key="hint" className="ml-form-field-helptext">{ hint }</div> }
                { hasError && <div key="error" className="ml-form-field-errortext">{ error }</div> }
            </label>
        </div>
    );
});

TextInput.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    hint: PropTypes.string,
    required: PropTypes.bool,
};

export default TextInput;
